define.alias("ember-power-select/components/power-select/placeholder", "media/components/power-select/placeholder");